var map = {
	"./14.Google-Marketing-Platform.jpg": 5252,
	"./15.Pinterest-1-1024x576.png": 5521,
	"./16.Twitter-1-1024x576.png": 6129,
	"./17.tiktok-logo.png": 6144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 749;